<template>
  <div id="breadCrumb">
    <div class="inner">
      <ul>
        <li>HOME</li>
        <li>
          <p class="pageTxt">{{ firTitle }}</p>
          <!-- <ul class="depth">
            <li v-for="(item, index) in firMenuList" :key="index">
              <router-link :to="item.link">{{ item.title }}</router-link>
            </li>
          </ul> -->
        </li>
        <li v-if="secTitle !== ''">
          <p class="pageTxt">{{ secTitle }}</p>
          <!-- <ul class="depth">
            <li v-for="(item, index) in secMenuList" :key="index">
              <router-link :to="item.link">{{ item.title }}</router-link>
            </li>
          </ul> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';

export default {
  computed: {
    ...mapGetters({
      menuList: 'getMenuList',
    }),
  },

  created() {
    this.getTitle();
  },

  data() {
    return {
      firMenuList: [],
      secMenuList: [],
      firTitle: '',
      secTitle: '',
    };
  },

  watch: {
    $route() {
      this.getTitle();
    },
  },

  methods: {
    getTitle() {
      this.firTitle = this.$route.meta.category[0];
      this.secTitle = this.$route.meta.category[1];
      this.getSnbMenuList();
    },

    getSnbMenuList() {
      const copy = cloneDeep(this.menuList);

      this.firMenuList = copy.filter(v => {
        if (v.menuList) {
          v.menuList = v.menuList.filter(i => i != '');
        }
        return v;
      });

      for (let j = 0; j < copy.length; j++) {
        if (copy[j].title === this.firTitle) {
          this.secMenuList = copy[j].menuList;
          copy[j].menuList.map(item => {
            if (item.title === this.secTitle) this.trdMenuList = item.menuList;
          });
        }
      }
    },
  },
};
</script>
